import {
  GetPlace,
  GetPlaceLanguage,
  DeletePlaceTranslation,
  GetPlaceCheckinQrCode,
  GetPlaceRatingQrCode,
  GetPlaceRatings,
  DeletePlaceRating,
  AddModeratorToPlace,
  RemovePlaceModerator,
  GetPlaceContributions,
  DeletePlaceContributions
} from '../../api/place'
import {
  GetQuizes,
  DeleteQuiz,
  UpdateQuiz,
  GetQuizQrCode,
  TranslateQuiz,
  TranslateQuizAnswer,
  DeleteQuizTranslation,
  UpdateQuizTranslation,
  UpdateQuizAnswerTranslation,
  DeleteQuizAnswerTranslation
} from '../../api/quiz'
import { GetImages } from '../../api/images'
import { prepareFormData } from '../../helpers'

const state = {
  current: {},
  currentPlaceQuizes: {},
  currentPlaceImages: [],
  currentPlaceLangs: [],
  currentPlaceRatings: {},
  currentPlaceContributions: {},
  qrCodes: {}
}
const getters = {
  Place: (state) => state.current,
  PlaceQuizes: (state) => state.currentPlaceQuizes,
  PlaceImages: (state) => state.currentPlaceImages,
  PlaceLanguages: (state) => state.currentPlaceLangs,
  PlaceQrCodes: (state) => state.qrCodes
}
const mutations = {
  addCurrentPlace: (state, payload) => {
    state.current = payload
  },
  populateQuizes: (state, payload) => {
    state.currentPlaceQuizes = payload
  },
  populateImages: (state, payload) => {
    state.currentPlaceImages = payload
  },
  populateLanguages: (state, payload) => {
    state.currentPlaceLangs = payload
  },
  addQrCode: (state, payload) => {
    state.qrCodes[payload.type] = payload.qrcode
  },
  populateRatings: (state, payload) => { state.currentPlaceRatings = payload },
  populateContributions: (state, payload) => { state.currentPlaceContributions = payload }
}
const actions = {
  // Place
  SetCurrentPlace: ({state, commit}, payload) => {
    commit('addCurrentPlace', payload)
  },
  RetrievePlace: ({state, commit}, payload) => {
    if (payload) {
      return new Promise((resolve, reject) => {
        GetPlace(payload)
          .then(
            success => {
              commit('addCurrentPlace', success.data)
              resolve()
            },
            error => {
              reject(error)
            }
          )
      })
    }
  },
  // Images
  SetCurrentPlaceImages: ({state, commit}, payload) => {
    commit('populateImages', payload)
  },
  RetrievePlaceImages: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      if (state.currentPlaceImages.length === 0 || (typeof payload.force === 'boolean' && payload.force)) {
        GetImages(
          payload.params.limit,
          payload.params.skip,
          payload.params.language,
          payload.params.id
        )
          .then(
            success => {
              commit('populateImages', success.data.items)
              resolve()
            },
            error => {
              reject(error)
            }
          )
      } else {
        resolve()
      }
    })
  },
  // Quizes
  SetCurrentPlaceQuizes: ({state, commit}, payload) => {
    commit('populateQuizes', payload)
  },
  RetrievePlaceQuizes: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      GetQuizes(
        payload.params.limit,
        payload.params.skip,
        payload.params.language,
        payload.params.id
      )
        .then(
          success => {
            // console.log(success.data)
            let quizes = {...state.currentPlaceQuizes}
            quizes[payload.params.language] = success.data.items
            commit('populateQuizes', quizes)
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  DeleteQuiz: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      DeleteQuiz(payload.placeId, payload.quiz.id)
        .then(
          success => {
            let quizes = [...state.currentPlaceQuizes]
            quizes.splice(quizes.indexOf(payload.quiz), 1)
            commit('populateQuizes', quizes)
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  AddAnswerToQuiz: ({ state, commit }, payload) => {
    let quizes = {...state.currentPlaceQuizes}
    quizes[payload.language][0].answers.push(payload)
    commit('populateQuizes', quizes)
  },
  RemoveAnswerToQuiz: ({ state, commit }, payload) => {
    let quizes = {...state.currentPlaceQuizes}
    let index = quizes[payload.language][0].answers.indexOf(payload)
    if (index > -1) {
      quizes.splice(index, 1)
      commit('populateQuizes', quizes)
    }
  },
  UpdateQuiz: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      const { quiz, params } = payload
      let data = {
        title: quiz.title,
        description: quiz.description
      }
      UpdateQuiz(
        prepareFormData(data),
        params.placeId,
        params.quizId,
        params.languageId
      )
        .then(
          success => {
            let quizes = {...state.currentPlaceQuizes}
            let index = quizes[quiz.language].indexOf(quiz)
            quizes[quiz.language][index] = quiz
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  translateQuiz: async ({ state, commit }, payload) => {
    try {
      const success = await TranslateQuiz(payload)
      let { currentPlaceQuizes } = state
      currentPlaceQuizes[payload.data.language] = [success.data]
      commit('populateQuizes', currentPlaceQuizes)
    } catch (error) {
      throw error
    }
  },
  translateQuizAnswer: async ({ state, commit, dispatch }, payload) => {
    try {
      await TranslateQuizAnswer(payload)
      // let { currentPlaceQuizes } = state
      // if (!currentPlaceQuizes[payload.data.language][0].answers) {
      //   currentPlaceQuizes[payload.data.language][0].answers = [success.data]
      // } else {
      //   currentPlaceQuizes[payload.data.language][0].answers.push(success.data)
      // }
      // commit('populateQuizes', currentPlaceQuizes)
      const { current } = state
      await dispatch('RetrievePlaceQuizes', { params: { limit: 100, skip: 0, language: payload.data.language, id: current.id } })
    } catch (error) {
      throw error
    }
  },
  deleteQuizTranslation: async ({ state, commit }, payload) => {
    try {
      const { language } = payload
      delete payload.language
      await DeleteQuizTranslation(payload)
      let { currentPlaceQuizes } = state
      currentPlaceQuizes[language] = []
      commit('populateQuizes', currentPlaceQuizes)
    } catch (error) {
      throw error
    }
  },
  updateQuizTranslation: async ({ state, commit, dispatch }, payload) => {
    try {
      const { language } = payload.data
      delete payload.data.language
      await UpdateQuizTranslation(payload)
      // let { currentPlaceQuizes } = state
      // currentPlaceQuizes[language][0] = success
      // commit('populateQuizes', currentPlaceQuizes)
      const { current } = state
      await dispatch('RetrievePlaceQuizes', { params: { limit: 100, skip: 0, language, id: current.id } })
    } catch (error) {
      throw error
    }
  },
  updateQuizAnswerTranslation: async ({ state, commit, dispatch }, payload) => {
    try {
      // const { language } = payload.data
      delete payload.data.language
      await UpdateQuizAnswerTranslation(payload)
      const { current } = state
      await dispatch('RetrievePlaceQuizes', { params: { limit: 100, skip: 0, language: current.language, id: current.id } })
      // let { currentPlaceQuizes } = state
      // let answer = currentPlaceQuizes[language][0].answers.find(answer => answer.id === payload.answerId)
      // currentPlaceQuizes[language][0].answers[currentPlaceQuizes[language][0].answers.indexOf(answer)] = success.data
      // commit('populateQuizes', currentPlaceQuizes)
      // console.log(success)
    } catch (error) {
      throw error
    }
  },
  deleteQuizAnswerTranslation: async ({ state, commit }, payload) => {
    try {
      const { language } = payload
      delete payload.language
      const success = await DeleteQuizAnswerTranslation(payload)
      let { currentPlaceQuizes } = state
      let answer = currentPlaceQuizes[language][0].answers.find(answer => answer.id === payload.answerId)
      currentPlaceQuizes[language][0].answers.splice(currentPlaceQuizes[language][0].answers.indexOf(answer), 1)
      commit('populateQuizes', currentPlaceQuizes)
      console.log(success)
    } catch (error) {
      throw error
    }
  },
  // Place Language
  SetCurrentPlaceLanguages: ({state, commit}, payload) => {
    commit('populateLanguages', payload)
  },
  RetrievePlaceLanguage: ({state, commit}, payload) => {
    return new Promise((resolve, reject) => {
      if (state.currentPlaceLangs.length === 0 || (typeof payload.force === 'boolean' && payload.force)) {
        GetPlaceLanguage(payload.params.id)
          .then(
            success => {
              commit('populateLanguages', success.data.items)
              resolve()
            },
            error => {
              reject(error)
            }
          )
      }
    })
  },
  DeletePlaceLanguage: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      let translations = [...state.currentPlaceLangs]
      let indexToRemove = translations.indexOf(payload.translation)
      if (indexToRemove > -1) {
        const { placeId, translationId } = payload.params
        DeletePlaceTranslation(
          placeId,
          translationId
        )
          .then(
            success => {
              translations.splice(indexToRemove, 1)
              commit('populateLanguages', translations)
              resolve()
            },
            error => {
              reject(error)
            }
          )
      } else {
        // eslint-disable-next-line
        reject({ response: 'tradução não encontrada' })
      }
    })
  },
  // QR Codes
  RetrievePlaceCheckinQrCode: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      GetPlaceCheckinQrCode(payload)
        .then(
          success => {
            commit('addQrCode', {
              type: 'checkin',
              qrcode: success.data.url
            })
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  RetrievePlaceQuizQrCode: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      const { placeId, quizId } = payload.params
      GetQuizQrCode(placeId, quizId)
        .then(
          success => {
            commit('addQrCode', {
              type: 'quiz',
              qrcode: success.data.url
            })
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  RetrievePlaceRatingQrCode: ({ state, commit }, payload) => {
    return new Promise((resolve, reject) => {
      GetPlaceRatingQrCode(payload)
        .then(
          success => {
            commit('addQrCode', {
              type: 'rating',
              qrcode: success.data.url
            })
            resolve()
          },
          error => {
            reject(error)
          }
        )
    })
  },
  // ratings
  getPlaceRatings: async ({ state, commit }, payload) => {
    try {
      const success = await GetPlaceRatings(payload)
      commit('populateRatings', success.data)
      return success.data
    } catch (error) {
      throw error
    }
  },
  deletePlaceRating: async ({ state, commit }, payload) => {
    try {
      await DeletePlaceRating(payload)
      const { currentPlaceRatings } = state
      currentPlaceRatings.items = currentPlaceRatings.items.filter(item => item.id !== payload.id)
      commit('populateRatings', currentPlaceRatings)
    } catch (error) {
      throw error
    }
  },
  addModeratorToPlace: async ({ state, commit }, payload) => {
    try {
      const success = await AddModeratorToPlace(payload)
      const { moderators } = success.data
      const { current } = state
      commit('addCurrentPlace', { ...current, moderators })
    } catch (error) {
      throw error
    }
  },
  removePlaceModerator: async ({ state, commit }, payload) => {
    try {
      const success = await RemovePlaceModerator(payload)
      console.log(success)
    } catch (error) {
      throw error
    }
  },
  getPlaceContributions: async ({ state, commit }, payload) => {
    try {
      const success = await GetPlaceContributions(payload)
      commit('populateContributions', success.data)
      return success.data
    } catch (error) {
      throw error
    }
  },
  deletePlaceContribution: async ({ state, commit }, payload) => {
    try {
      await DeletePlaceContributions(payload)
      let { currentPlaceContributions } = state
      const remove = currentPlaceContributions.items.filter(i => i.id !== payload.id)
      currentPlaceContributions.items = remove
      commit('populateContributions', currentPlaceContributions)
    } catch (error) {
      throw error
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/place.js